"use client";
import policy from '../../../config/bite-engagement.json';
import type {ObservedSection} from './bite-report-observation';
export type ReadingCounter={section:string;metric:string;value:number};
type DocumentIdentity={ticker:string;reportId:string;kind:'example'|'report'|'stage'};
let testStatus:Promise<boolean>|undefined;
export function isTestVisit() {
  try{if(localStorage.getItem('bite_measurement_test')==='true')return Promise.resolve(true);}catch{/* storage unavailable */}
  if(navigator.webdriver||/^(localhost|127\.0\.0\.1)$/.test(location.hostname)||new URLSearchParams(location.search).get('bite_measurement_test')==='true')return Promise.resolve(true);
  // Only a test flag crosses this boundary; account data never enters reading packets.
  return testStatus??=fetch('/api/me',{credentials:'same-origin'}).then(r=>r.json()).then(data=>data.isAdmin===true).catch(()=>false);
}
export function createReadingSender(identity:DocumentIdentity) {
  const test=isTestVisit();
  return (counters:ReadingCounter[])=>{
    if(!counters.length)return;
    const packet={...identity,eventId:crypto.randomUUID(),day:new Date().toISOString().slice(0,10),counters};
    const send=async(attempt=0):Promise<void>=>{
      try {
        const response=await fetch('/api/analytics/bite-reading',{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',keepalive:true,
          headers:{'Content-Type':'application/json'},body:JSON.stringify({...packet,isTest:await test})});
        if(response.status>=400&&response.status<500)return;
        if(!response.ok)throw new Error('reading_delivery');
      }catch{if(attempt<3)setTimeout(()=>void send(attempt+1),policy.publishMs);}
    };
    void send();
  };
}
export function createReadingCounterDelta() {
  const previous=new Map<string,number>();let opened=false,finished=false;
  return (snapshot:{sections:ObservedSection[];lastSection:string},ending=false):ReadingCounter[]=>{
    const output:ReadingCounter[]=[];
    const add=(section:string,metric:string,value:number)=>{const key=`${section}:${metric}`,delta=value-(previous.get(key)||0);if(delta>0){output.push({section,metric,value:delta});previous.set(key,value);}};
    if(!opened){add('report','opens',1);opened=true;}
    const furthest=Math.max(-1,...snapshot.sections.filter(s=>s.visits>0).map(s=>s.index));
    for(const section of snapshot.sections){
      add(section.id,'reached',Number(section.visits>0));add(section.id,'read',Number(section.activeMs>=policy.readThresholdMs));
      add(section.id,'revisited',Number(section.visits>1));add(section.id,'activeMs',section.activeMs);add(section.id,'visibleMs',section.visibleMs);
      if(ending&&!finished){add(section.id,'passedQuickly',Number(section.index<furthest&&section.activeMs<policy.readThresholdMs));add(section.id,'exits',Number(snapshot.lastSection===section.id));}
    }
    if(ending)finished=true;
    return output;
  };
}
